import { useState } from 'react';
import DateInput from 'common/components/form/inputs/date';

import DangerousActionModal from 'common/components/modals/DangerousActionModal';
import NumberInput from 'common/components/form/inputs/NumberInput';
import editEmpty from 'assets/svg/actions/edit-empty.svg';
import save from 'assets/svg/actions/save.svg';
import remove from 'assets/svg/actions/remove.svg';
import SvgRender from 'common/components/general/SvgRender';
import { formatDate } from 'common/utils/dates';
import { formattedValue } from '../editValuesForm/helpers';

const SingleBulkValue = ({
  mode,
  className,
  onNumberInputChange,
  dateError,
  selected,
  onAddClick,
  values,
  date,
  onDateChange,
  displayDate,
  items,
  valueError,
  onEditClick,
  onDeleteClick,
  disabled,
  setDeleting
}) => {
  const [modalOpen, setModal] = useState(false);
  if (mode === 'display' && !items) return null;

  return (
    <div className={`bulk-value d-flex justify-content-start align-items-center ${className}`}>
      {(mode === 'add' || mode === 'edit') && (
        <>
          <div className="date-cell">
            {mode === 'add' ? (
              <DateInput
                error={dateError}
                className={`edit-input`}
                hasTime={false}
                value={date}
                onChange={date => onDateChange(date)}
              />
            ) : (
              <div className="cell-display ps-3 d-flex align-items-center justify-content-start">
                {formatDate(displayDate, { time: true })}
              </div>
            )}
          </div>
          {selected.map((el, i) => (
            <div key={el.id} className="index-cell">
              <NumberInput
                error={i === 0 ? valueError : ''}
                value={values[i]}
                className="edit-input"
                onChange={e => onNumberInputChange(e.target.value, i)}
                placeholder="Value"
                decimalScale={4}
              />
            </div>
          ))}
          <div className="d-flex align-items-center ms-2 mb-2">
            {mode === 'edit' && (
              <div
                onClick={() => {
                  setModal(true);
                  setDeleting(true);
                }}
                className={`circled-button circled-button-delete me-1 ${
                  disabled ? 'disabled' : ''
                }`}
              >
                <SvgRender className="text-white" src={remove} style={{ width: 10 }} />
              </div>
            )}
            <div
              onClick={onAddClick}
              className={`circled-button circled-button-save ${disabled ? 'disabled' : ''}`}
            >
              <SvgRender src={save} className="text-white" style={{ width: 12 }} />
            </div>
          </div>
          <div className="block" />
        </>
      )}
      {mode === 'display' && (
        <>
          <div className="date-cell">
            <div className="cell-display ps-3 d-flex align-items-center justify-content-start">
              {formatDate(displayDate, { time: true })}
            </div>
          </div>
          {items.map((el, i) => {
            return (
              <div key={i} className="index-cell">
                <div className="cell-display ps-3 d-flex align-items-center justify-content-start">
                  {el ? formattedValue(el) : '-'}
                </div>
              </div>
            );
          })}

          <div onClick={onEditClick} className={`circled-button circled-button-display ms-2`}>
            <SvgRender src={editEmpty} className="text-white" style={{ width: 12 }} />
          </div>
        </>
      )}
      <DangerousActionModal
        transparent
        onAccept={onDeleteClick}
        closeModal={() => {
          setModal(false);
          setDeleting(false);
        }}
        isOpen={modalOpen}
        actionText="DELETE"
        header="Delete Values"
        body={
          <div className="text-center">
            You are about to delete these values. <br />
            Are you sure you want to continue?
          </div>
        }
      />
    </div>
  );
};

export default SingleBulkValue;
